import Node from 'ln/node/Node';
import View from 'ln/view/View';
import Model from 'ln/model/Model';
import ListRenderer from 'ln/list/ListRenderer';
import Lang from 'ln/lang/Lang';
import UserCourseModel from '../models/UserCourseModel';
import UserModel from '../models/UserModel';
import TagEditor from '../../general/TagEditor';
import CourseElementsIoC from '../CourseElementsIoC';
import moment from 'moment';
import setup from 'ln/setup/setup';
import { scanner } from 'ln/view/Scanner';

class Course extends View {
	
	public listRenderer:ListRenderer<Model>;
	public guestRenderer:ListRenderer<UserModel>;
	
	constructor( public model:UserCourseModel ) {
		super( model );
		this.defaultTemplate = 'krw.usercourse';

		this.model.guestusers.added.add( () => { this.model.save() }, this );
		this.model.guestusers.removed.add( () => { this.model.save() }, this );

		this.model.sequences.added.add( () => { this.model.save() }, this );
		this.model.sequences.removed.add( () => { this.model.save() }, this );

	}
	
	public init() {
		
		this.listRenderer = new ListRenderer<Model>( Node.js( 'course-elements' ) );

		// register 
		this.listRenderer.ioc = new CourseElementsIoC<Model>( this );
		
		this.model.sequences.added.add( this.rerenderComputedProperties, this );
		this.model.sequences.removed.add( this.rerenderComputedProperties, this );

		if( !this.model.previewMode ){

			// listen for changes
			this.node.js( 'course-title' ).blur.add( this.onTitleChange, this );
			this.node.js( 'course-location' ).blur.add( this.onLocationChange, this );
			this.node.js( 'course-participants' ).change.add( this.onParticipantsChange, this );
			this.node.js( 'material' ).blur.add( this.onMaterialChange, this );
			this.node.js( 'general-infos' ).blur.add( this.onInfosChange, this );
			this.node.js( 'notes' ).blur.add( this.onNotesChange, this );
			this.node.js( 'course-customer' ).blur.add( this.onCustomerChange, this );
	
			this.renderGuestUserTagEditor();

			// this.model.
			
		}

		this.node.js('expand').click.add( this.toggleExpand, this );
		
		Node.js( 'view-menu' ).click.add( this.toggleAllDays, this );

		this.renderSequences();

		scanner.scan( this.node );
		
	}
	
	private toggleExpand(){
		this.node.js('expandable').toggleClass( 'hidden' );
		this.node.js('expand-btn').toggleClass( 'rotate-180' );
	}

	renderSequences() {
		this.listRenderer.source = this.model.sequences;

		if( this.model.sequences.all().some( sequence => sequence.modelName == 'App\\FeedbackSequence' ) ){
			this.node.js( 'course-elements' ).addClass( '-with-feedback-sequence' );
		}
	}
	
	private onTitleChange( n:Node ){
		this.model.title = n.value;
		this.model.save();
	}
	
	private onLocationChange( n:Node ){
		this.model.location = n.value;
		this.model.save();
	}
	
	private onParticipantsChange( n:Node ){
		this.model.participants = parseInt( n.value );
		this.model.save();
	}

	private onMaterialChange( n:Node ){
		this.model.set( 'material', n.html );
		this.model.save();
	}

	private onInfosChange( n:Node ){
		this.model.set( 'general_infos', n.html );
		this.model.save();
	}

	private onNotesChange( n:Node ){
		this.model.set( 'note', n.html );
		this.model.save();
	}

	private onCustomerChange( n:Node ){
		this.model.set( 'customer', n.value );
		this.model.save();
	}
	
	public rerenderComputedProperties(){
		this.node.js( 'date' ).html = moment( this.model.firstDaybreak.date, 'YYYY-MM-DD' ).format('DD.MM.YYYY');
		let hours = Math.floor( this.model.duration / 60 );
		let minutes = this.model.duration % 60;
		this.node.js( 'duration' ).html = hours + ( ( hours > 1 ) ? ' ' + Lang.translate( 'units.hour.plural') + ' ' : ' ' + Lang.translate( 'units.hour.singular' ) + ' ' ) + minutes + ' ' + Lang.translate( 'units.minute.plural' );
		this.node.js( 'days' ).html = this.model.days.toString();

		let pauseDuration = this.node.js( 'pauseDuration' );
		pauseDuration.html = this.model.pauseDuration + ' ' + Lang.translate( 'units.minute.plural' );
		pauseDuration.toggleClass( 'invalid', ( this.model.get( 'certified' ) && this.model.pauseDuration ) < this.model.get( 'certified_pauseduration' ) );
	}
	
	public toggleDaybreak( n:Node ){
		this.toggleAllElements( n, n.hasClass( 'collapsed' ) );
		n.toggleClass( 'collapsed' );
	}
	
	public toggleAllElements( n:Node, show:boolean = true ){

		var native = <HTMLElement> n.native.nextSibling;

		while( native != null ) {

			var next = Node.fromNative( native );
			if( next.hasClass( 'daybreak' ) ) break;
			next.toggleClass( 'hidden', !show );

			native = <HTMLElement> native.nextSibling;
		}
	}
	
	private toggleAllDays( n:Node ){
		let daybreaks = this.node.all( '.daybreak' );
		daybreaks.forEach( ( n:Node ) => {
			if( !n.hasClass( 'collapsed' ) ) this.toggleDaybreak( n );
		});
	}

	private renderGuestUserTagEditor( ) { 


		var filterFunction = ( user ) => {
			return user.id != this.model.get<UserModel>( 'owner' ).id;
		}

		setup.route( 'api.users' ).load().then( ( userlist:any ) => {
			var tagEditor = new TagEditor( this.model.guestusers );

			// remove owner so that course can't be shared with its owner
			userlist = userlist.filter( filterFunction );

			tagEditor.setChoices( userlist );
			tagEditor.render( this.node.js( 'guest-users' ) );
		});
	}
}

export default Course;